import Vue from 'vue'
import Router from 'vue-router'
// 客户路由
// import customer from './customer'
// 工作台路由
import workbench from './workbench'
// 拓客管理路由
import memberCenter from './memberCenter'
// 会员分析路由
import memberAnalyse from './memberAnalyse'
// 营销分析路由
import marketAnalyse from './marketAnalyse'

import marketingCenter from './marketingCenter'
// 系统管理路由
import systemSetup from './systemSetup'

import biCockpit from './biCockpit'

const Login = () => import('@/view/login')
const cockpit = () => import('@/view/biCockpit/cockpit')
// 路由版本 有时 push  会报错， 这里避免阻塞，处理下
//获取原型对象上的push函数
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  try {
    return originalPush.call(this, location).catch(err => err)
  } catch (error) {
    
  }
};
const originalReplace = Router.prototype.replace
Router.prototype.replace = function push(location) {
  try {
    return originalReplace.call(this, location).catch(err => err)
  } catch (error) {

  }
}

Vue.use(Router);

const router = new Router({
  routes: [{
      path: '',
      redirect: '/login'
    }, {
      path: '/login',
      name: 'login',
      component: Login
    },
    ...workbench,
    ...memberCenter,
    ...memberAnalyse,
    ...marketAnalyse,
    ...marketingCenter,
    ...systemSetup,
    ...biCockpit
  ]
});

export default router;